// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"e3fbf766","311":"eee4526c","726":"1a2dbcbe","843":"5ce60e23"}[chunkId] + ".chunk.js";
};